var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomersHilights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2880",
    "data-name": "Group 2880",
    transform: "translate(-140 -2245)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1309",
    "data-name": "Rectangle 1309",
    width: 24,
    height: 24,
    transform: "translate(140 2245)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(9.031 2121.84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon6",
    transform: "translate(131.969 125.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M-4.814-18.512H13.595m-.2-1.5-9-4.792-9,4.792ZM-4.325-9.185h17.43m-18.434,1.7H14.11m-20.559,1.7H15.23M-3.046-18.466v9.28m2.24-9.28v9.28M3.1-18.466v9.28m2.241-9.28v9.28m3.908-9.28v9.28m2.24-9.28v9.28",
    transform: "translate(6.449 24.8)",
    fill: "none",
    stroke: "#15355c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersHilights);
export default __webpack_public_path__ + "static/media/customers_hilights.4edd958d3c5c6976b1167ffa4c6dde0e.svg";
export { ForwardRef as ReactComponent };